export default [
	{
		path: '/reset_password',
		lazy: async () => {
			const Module = await import('../../pages/services/admin/ResetPasswordPage');
			return { Component: Module.default };
		},
	},
];
